import React from 'react'
import Skeleton from "react-loading-skeleton";

const KioskHomeBannerSkeleton = () => {
  return (
    <div style={{ lineHeight: 1 }} >
      <Skeleton height={222} />
    </div>
  )
}

export default KioskHomeBannerSkeleton
